const formSettings = {
  fields: [
    {
      key: 'firstName',
      type: 'text',
      isRequired: true,
      name: 'First Name',
      maxLength: 40,
      pattern: /^[a-z ,.'-]+$/i
    },
    {
      key: 'lastName',
      type: 'text',
      isRequired: true,
      name: 'Last Name',
      maxLength: 80,
      pattern: /^[a-z ,.'-]+$/i
    },
    {
      key: 'dateOfBirth',
      type: 'date',
      isRequired: true,
      name: 'Date of Birth',
      maxLength: 10,
      pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/
    },
    {
      key: 'phone',
      type: 'phone',
      isRequired: true,
      name: 'Phone',
      maxLength: 40,
      pattern: /^\+?(?!11)\d{10,40}$/i
    },
    {
      key: 'email',
      type: 'email',
      isRequired: true,
      name: 'Email',
      maxLength: 80,
      pattern:
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
    },
    {
      key: 'message',
      type: 'textarea',
      isRequired: true,
      name: 'Message',
      maxLength: 1024,
      pattern: /^[ a-z0-9~!@#$%^&*()_+=\-|\\\][{}'’;":/?.>,<\r\n]*$/i
    }
  ],
  submitBtn: {
    text: 'Submit'
  }
};

export default formSettings;
